import React from "react";

import { Tooltip } from "../tooltip/Tooltip";

export interface CtxMenuItemProps {
	disabled?: boolean;
	label: React.ReactNode;
	title?: React.ReactNode;
	onClick?: React.MouseEventHandler<any>;
}

export const CtxMenuItem: React.FC<CtxMenuItemProps> = ({ label, title, onClick, ...restProps }) => (
	// tooltip should be wrapped with div to properly display menu item
	<div>
		<Tooltip placement="left" title={title}>
			<div {...restProps}>{label}</div>
		</Tooltip>
	</div>
);
